export default {
  dataPhilter: "user-eligible-addons",
  purchasedText: "Purchased",
  spyName: "Spy on your Rival"
};
